export default "__VITE_ASSET__DB0dzbQj__"